interface TextInputProps
	extends React.DetailedHTMLProps<
		React.InputHTMLAttributes<HTMLInputElement>,
		HTMLInputElement
	> {}

const TextField = (props: TextInputProps) => {
	return <input {...props} />;
};

export default TextField;
